<template>
  <div class="appearance">
    <AppearanceForm />
  </div>
</template>

<script>
import AppearanceForm from "./Appearance/AppearanceForm.vue";
export default {
  components: {
    AppearanceForm,
  },
};
</script>

<style scpoed>
.appearance {
  overflow: auto;
  height: calc(100vh - 66px);
  width: 100%;
  padding: 62px 38px 38px 38px;
}
</style>
